import { axiosInstance } from './axiosInstance';

// Types for penalty API responses
export interface PenaltyPaymentDto {
  id: string;
  landlordId: string;
  applicationId: string;
  estateId: string | null;
  penaltyType: 'LateCountersign';
  status: 'Pending' | 'PaymentInProcess' | 'Paid' | 'OnHold' | 'Cancelled';
  paymentIntentId: string | null;
  penaltyAmount: number;
  createdAt: string;
  isPaid: boolean;
}

export interface PenaltiesResponse {
  individualPenalties: PenaltyPaymentDto[];
  bulkPenalty: PenaltyPaymentDto | null;
}

export interface EstatePenaltiesResponse {
  estateId: string;
  penalties: PenaltyPaymentDto[];
}

export interface CreatePenaltyStripePaymentResponse {
  paymentIntentId: string;
  clientSecret: string;
  amount: number;
  currency: string;
  penaltyPaymentId: string;
  status: string;
}


// API functions
export const getAllPenalties = async (): Promise<PenaltiesResponse> => {
  try {
    const response = await axiosInstance.get('/billings/penalty');
    return response.data || response;
  } catch (error) {
    console.error('Penalty API Error:', error);
    return { individualPenalties: [], bulkPenalty: null };
  }
};

export const createPenaltyStripePayment = async (
  bulkPenaltyId: string,
): Promise<CreatePenaltyStripePaymentResponse> => {
  const response = await axiosInstance.post(`/billings/penalty/${bulkPenaltyId}/create-payment`);

  return response.data || response;
};



